
import { ApiService } from '../shared/services/api-service/api.service';
import { ICybersourcePayerAuthSetupResponse, ICybersourcePayerAuthSetupPayload } from './interfaces/cybersource-payment.interfaces';


class CybersourcePaymentServiceClass {
    async getCybersourcePayerAuthSetUp(hotelCode: number, payload: ICybersourcePayerAuthSetupPayload) {
        try {
            const cybersourcePayerAuthSetupResponse: Response = await ApiService.
                getCybersourcePayerAuthSetUp(hotelCode, payload);
            const cybersourcePayerAuthSetupObject: ICybersourcePayerAuthSetupResponse = await cybersourcePayerAuthSetupResponse.json();
            return cybersourcePayerAuthSetupObject;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }
}

export const CybersourcePaymentService = new CybersourcePaymentServiceClass();
